import React from 'react';
import _ from 'lodash';
import { Box, Drawer, FormControl, InputLabel, MenuItem, Select, Button, Portal, Tooltip, Fab, Stack, Typography } from '@mui/material';
import { DebounceInput } from 'react-debounce-input';
import { useMutation } from 'react-fetching-library';
import AddIcon from '@mui/icons-material/Add';

import { useResponsive } from '../../../../services/hooks';
import { NAVBAR } from '../../../../utils/config';
import Scrollbar from '../../../../components/Scrollbar';
import { CssTextField } from '../../../../components/others/CssTextField';
import { SmallFormDateField } from '../../../../components/small-fields/SmallFormDateField';
import { formatDate } from '../../../../services/functions';
import { invoiceTypes } from '../../../../services/constants';
import { getListOfReceiptsReport, getListOfReceiptsExcelReport, downloadListOfInvoices, createSyntheticAccountsErrorsExcelReport, createFinishedEventsExcelReport, createSurchargeEventsExcelReport } from '../../../../services/request';
import toast from 'react-hot-toast';
import Iconify from '../../../../components/Iconify';

import DocumentsSpreadsheetModal from './DocumentsSpreadsheetModal';

import dayjs from 'dayjs';
import EventDateRangeModal from './EventDateRangeModal';

export const DocumentSidebar = props => {
  const { isOpenSidebar, onCloseSidebar, queryCallback, documents, openDocumentChoiceSignal } = props;
  const isDesktop = useResponsive('up', 'md');
  const { mutate } = useMutation(getListOfReceiptsReport);
  const { mutate: mutateExcel } = useMutation(getListOfReceiptsExcelReport);
  const { mutate: mutateInvoices, loading } = useMutation(downloadListOfInvoices);
  const { mutate: mutateSyntheticAccountsErrors, loading: synthLoading } = useMutation(createSyntheticAccountsErrorsExcelReport);
  const { mutate: mutateFinishedEvents, loading: finishedEventsLoading } = useMutation(createFinishedEventsExcelReport);
  const { mutate: mutateSurchargeEvents, loading: surchargeEventsLoading } = useMutation(createSurchargeEventsExcelReport);
  const [documentNumber, setDocumentNumber] = React.useState('');
  const [type, setType] = React.useState('');
  const [orderNumber, setOrderNumber] = React.useState('');
  const [agreementNumber, setAgreementNumber] = React.useState('');
  const [participantName, setParticipantName] = React.useState('');
  const [buyerName, setBuyerName] = React.useState('');
  const [user, setUser] = React.useState('');
  const [issueDateFrom, setIssueDateFrom] = React.useState(dayjs().subtract(10, 'day')
    .format('YYYY-MM-DD'));
  const [issueDateTo, setIssueDateTo] = React.useState('');
  const [valueFrom, setValueFrom] = React.useState('');
  const [valueTo, setValueTo] = React.useState('');
  const [value, setValue] = React.useState('');
  const [openModal, setOpenModal] = React.useState(false);
  const [eventDateFrom, setEventDateFrom] = React.useState(null);
  const [eventDateTo, setEventDateTo] = React.useState(null);
  const [openEventDateRangeModal, setOpenEventDateRangeModal] = React.useState(false);
  const [submitType, setSubmitType] = React.useState(null);

  const resetFilters = () => {
    setType('');
    setIssueDateFrom(null);
    setIssueDateTo(null);
    setValueFrom('');
    setValueTo('');
    setValue('');
  };

  React.useEffect(() => {
    let search = '?';
    if (!_.isEmpty(documentNumber)) {
      search += `document_number=${documentNumber}&`;
    }
    if (!_.isEmpty(orderNumber)) {
      search += `order_number=${orderNumber}&`;
    }
    if (!_.isEmpty(agreementNumber)) {
      search += `agreement_number=${agreementNumber}&`;
    }
    if (!_.isEmpty(participantName)) {
      search += `participant_name=${participantName}&`;
    }
    if (!_.isEmpty(buyerName)) {
      search += `buyer_name=${buyerName}&`;
    }
    if (!_.isEmpty(user)) {
      search += `user=${user}&`;
    }
    if (!_.isEmpty(value)) {
      search += `search=${value}&`;
    }
    if (!_.isEmpty(issueDateFrom)) {
      search += `issue_date_from=${issueDateFrom}&`;
    }
    if (!_.isEmpty(issueDateTo)) {
      search += `issue_date_to=${issueDateTo}&`;
    }
    if (!_.isEmpty(valueFrom)) {
      search += `value_from=${valueFrom}&`;
    }
    if (!_.isEmpty(valueTo)) {
      search += `value_to=${valueTo}&`;
    }
    if (!_.isNaN(type)) {
      search += `type=${type}&`;
    }
    queryCallback(search);
  }, [documentNumber, orderNumber, agreementNumber, participantName, buyerName, user, issueDateFrom, issueDateTo, type, value, valueFrom, valueTo]);

  const handleDownloadListOfReceiptsReport = async () => {
    console.log(type);
    const idList = documents.filter(document => {
      if (document.type === 5 || document.type === 6) {
        return true;
      }

      return false;
    }).map(document => document.id);

    const { error: mutateError, payload: mutatePayload } = await mutate({ 'id_list': idList, 'issue_date_from': issueDateFrom, 'issue_date_to': issueDateTo });
    if (!mutateError) {
      const url = window.URL.createObjectURL(mutatePayload);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = 'Zestawienie paragonów.pdf';
      a.click();
      window.URL.revokeObjectURL(url);
    } else {
      toast.error('Nie udało się pobrać zestawienia pargonów');
    }
  };

  const handleDownloadListOfReceiptsExcelReport = async () => {
    console.log(type);
    const idList = documents.filter(document => {
      if (document.type === 5 || document.type === 6) {
        return true;
      }

      return false;
    }).map(document => document.id);

    const { error: mutateError, payload: mutatePayload } = await mutateExcel({ 'id_list': idList, 'issue_date_from': issueDateFrom, 'issue_date_to': issueDateTo });
    if (!mutateError) {
      const url = window.URL.createObjectURL(mutatePayload);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = 'Raport paragonów.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);
    } else {
      toast.error('Nie udało się pobrać zestawienia pargonów');
    }
  };

  const handleDownloadListOfInvoicesReport = async () => {
    const idList = documents.filter(document => {
      if ([1, 2, 3, 4, 7, 9, 10].includes(document.type)) {
        return true;
      }

      return false;
    }).map(document => document.id);

    const { error: mutateError, payload: mutatePayload } = await mutateInvoices({ 'id_list': idList, 'issue_date_from': issueDateFrom, 'issue_date_to': issueDateTo });
    if (!mutateError) {
      const url = window.URL.createObjectURL(mutatePayload);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = 'Zestawienie faktur.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);
    } else {
      toast.error('Nie udało się pobrać zestawienia faktur');
    }
  };

  const handleDownloadSynteticAccountsErrors = async () => {
    const { error: mutateError, payload: mutatePayload } = await mutateSyntheticAccountsErrors({ 'issue_date_from': issueDateFrom, 'issue_date_to': issueDateTo });
    if (!mutateError) {
      const url = window.URL.createObjectURL(mutatePayload);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = 'Raport błędnie dobranych kont syntetycznych.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);
    } else {
      toast.error('Nie udało się pobrać raportu');
    }
  };

  const handleDownloadFinishedEventsReport = async () => {
    const { error: mutateError, payload: mutatePayload } = await mutateFinishedEvents({ 'date_from': eventDateFrom, 'date_to': eventDateTo });
    if (!mutateError) {
      const url = window.URL.createObjectURL(mutatePayload);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = `Raport dot. zakonczonych imprez w okresie ${eventDateFrom || ''}-${eventDateTo || ''}.xlsx`;
      a.click();
      window.URL.revokeObjectURL(url);
      setOpenEventDateRangeModal(false);
    } else {
      toast.error('Nie udało się pobrać raportu');
    }
  };

  const handleDownloadSurchargeEventsReport = async () => {
    const { error: mutateError, payload: mutatePayload } = await mutateSurchargeEvents({ 'date_from': eventDateFrom, 'date_to': eventDateTo });
    if (!mutateError) {
      const url = window.URL.createObjectURL(mutatePayload);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = `Raport zmian w zamówieniach po zakończeniu imprezy w okresie ${eventDateFrom || ''}-${eventDateTo || ''}.xlsx`;
      a.click();
      window.URL.revokeObjectURL(url);
      setOpenEventDateRangeModal(false);
    } else {
      toast.error('Nie udało się pobrać raportu');
    }
  };


  const renderContent = (
    <Scrollbar sx={{ maxHeight: 800 }}>
      <Box sx={{ p: 1, pr: '32px' }}>
        <Box display="flex" justifyContent="center">
          <Tooltip title="Dodaj dokument rozliczeniowy">
            <Fab
              color="primary"
              aria-label="add"
              onClick={() => {
                openDocumentChoiceSignal();
              }}
            >
              <AddIcon style={{ fontSize: '30px' }} />
            </Fab>
          </Tooltip>
        </Box>
        <Button
          variant="contained"
          sx={{ mt: 3, mb: 3 }}
          endIcon={<Iconify icon={'ph:file-pdf-bold'}/>}
          onClick={handleDownloadListOfReceiptsReport}
          disabled={[1, 2, 3, 4].includes(type)}
          fullWidth
        >
        zestawienie paragonów
        </Button>
        <Button
          variant="contained"
          sx={{ mb: 3 }}
          endIcon={<Iconify icon={'ri:file-excel-2-line'}/>}
          onClick={handleDownloadListOfReceiptsExcelReport}
          disabled={[1, 2, 3, 4].includes(type)}
          fullWidth
        >
        raport paragonów
        </Button>
        <Button
          variant="contained"
          sx={{ mb: 3 }}
          endIcon={<Iconify icon={'ri:file-excel-2-line'}/>}
          onClick={handleDownloadListOfInvoicesReport}
          disabled={loading}
          fullWidth
        >
        zestawienie faktur
        </Button>
        <Button
          variant="contained"
          sx={{ mb: 3 }}
          endIcon={<Iconify icon={'ri:file-excel-2-line'}/>}
          onClick={() => setOpenModal(true)}
          fullWidth
        >
        Wygeneruj Raport
        </Button>
        <Button
          variant="contained"
          sx={{ mb: 3 }}
          endIcon={<Iconify icon={'ri:file-excel-2-line'}/>}
          onClick={handleDownloadSynteticAccountsErrors}
          disabled={synthLoading}
          fullWidth
        >
        Raport błędnie dobranych kont syntetycznych
        </Button>
        <Button
          variant="contained"
          sx={{ mb: 3 }}
          endIcon={<Iconify icon={'ri:file-excel-2-line'}/>}
          onClick={() => {
            setOpenEventDateRangeModal(true);
            setSubmitType('finishedEvents');
          }}
          disabled={finishedEventsLoading}
          fullWidth
        >
        Raport zakończonych imprez
        </Button>
        <Button
          variant="contained"
          sx={{ mb: 3 }}
          endIcon={<Iconify icon={'ri:file-excel-2-line'}/>}
          onClick={() => {
            setOpenEventDateRangeModal(true);
            setSubmitType('surchargeEvents');
          }}
          disabled={surchargeEventsLoading}
          fullWidth
        >
        Raport zmian w zamówieniach po zakończeniu imprezy
        </Button>
        <Button
          variant="contained"
          sx={{ mb: 4 }}
          onClick={resetFilters}
          fullWidth
        >
        Zresetuj filtry
        </Button>
        <FormControl sx={{ width: '100%', mb: 2 }}>
          <InputLabel id="type-select" sx={{ ml: -2 }}>Rodzaj dokumentu...</InputLabel>
          <Select
            id="type-select"
            value={type}
            onChange={e => setType(e.target.value)}
            label="Rodzaj dokumentu..."
            variant="standard"
          >
            <MenuItem value=""></MenuItem>
            {_.map(invoiceTypes, item => (
              <MenuItem key={item.code} value={item.code}>{item.name}</MenuItem>
            ))
            }
          </Select>
        </FormControl>
        <DebounceInput
          debounceTimeout={1000}
          sx={{ width: '100%', mb: 2 }}
          element={CssTextField}
          placeholder="Szukaj..."
          label="Szukaj dokumentu"
          value={value}
          onChange={e => setValue(e.target.value)
          }
          variant="standard"
        />
        {/* <DebounceInput
          debounceTimeout={1000}
          sx={{ width: 200, mb: 2 }}
          element={CssTextField}
          placeholder="Numer dokumentu..."
          label="Numer dokumentu"
          value={documentNumber}
          onChange={e => setDocumentNumber(e.target.value)
          }
          variant="standard"
        />
        <DebounceInput
          debounceTimeout={1000}
          sx={{ width: 200, mb: 2 }}
          element={CssTextField}
          placeholder="Numer zamówienia..."
          label="Numer zamówienia"
          value={orderNumber}
          onChange={e => setOrderNumber(e.target.value)
          }
          variant="standard"
        />
        <DebounceInput
          debounceTimeout={1000}
          sx={{ width: 200, mb: 2 }}
          element={CssTextField}
          placeholder="Numer umowy..."
          label="Numer umowy"
          value={agreementNumber}
          onChange={e => setAgreementNumber(e.target.value)
          }
          variant="standard"
        />
        <DebounceInput
          debounceTimeout={1000}
          sx={{ width: 200, mb: 2 }}
          element={CssTextField}
          placeholder="Nazwa uczestnika..."
          label="Nazwa uczestnika"
          value={participantName}
          onChange={e => setParticipantName(e.target.value)
          }
          variant="standard"
        />
        <DebounceInput
          debounceTimeout={1000}
          sx={{ width: 200, mb: 2 }}
          element={CssTextField}
          placeholder="Numer kontrahenta..."
          label="Numer kontrahenta"
          value={buyerName}
          onChange={e => setBuyerName(e.target.value)
          }
          variant="standard"
        />
        <DebounceInput
          debounceTimeout={1000}
          sx={{ width: 200, mb: 4 }}
          element={CssTextField}
          placeholder="Wystawiający..."
          label="Wystawiający"
          value={user}
          onChange={e => setUser(e.target.value)
          }
          variant="standard"
        /> */}
        <SmallFormDateField
          sx={{ width: '100%', mb: 2 }}
          name="issue_date_from"
          type="text"
          label="Data wystawienia od"
          variant="standard"
          value={issueDateFrom}
          onChange={val => setIssueDateFrom(formatDate(val))}
        />
        <SmallFormDateField
          sx={{ width: '100%', mb: 2 }}
          name="issue_date_to"
          type="text"
          label="Data wystawienia do"
          variant="standard"
          value={issueDateTo}
          onChange={val => setIssueDateTo(formatDate(val))}
        />
        <Stack direction="row" justifyContent="space-between">
          <DebounceInput
            debounceTimeout={1000}
            sx={{ flex: 0.45, mb: 2 }}
            element={CssTextField}
            placeholder="od"
            label="od wartości"
            value={valueFrom}
            onChange={e => setValueFrom(e.target.value)
            }
            variant="standard"
            type="number"
          />
          <DebounceInput
            debounceTimeout={1000}
            sx={{ flex: 0.45, mb: 2 }}
            element={CssTextField}
            placeholder="do"
            label="do wartości"
            value={valueTo}
            onChange={e => setValueTo(e.target.value)
            }
            variant="standard"
            type="number"
          />
        </Stack>

      </Box>
      {openModal ? <DocumentsSpreadsheetModal handleClose={() => setOpenModal(false)} documents={documents}/> : null}
      {openEventDateRangeModal
        ? <EventDateRangeModal
          handleClose={() => setOpenEventDateRangeModal(false)}
          eventDateFrom={eventDateFrom}
          eventDateTo={eventDateTo}
          setEventDateFrom={val => setEventDateFrom(val)}
          setEventDateTo={val => setEventDateTo(val)}
          handleSubmit={submitType == 'finishedEvents' ? handleDownloadFinishedEventsReport : handleDownloadSurchargeEventsReport}
          isLoading={finishedEventsLoading}
        />
        : null}
    </Scrollbar>
  );

  return (
    <>
      {isDesktop ? (
        <Drawer variant="permanent" PaperProps={{ sx: { width: NAVBAR.BASE_WIDTH + 20, position: 'relative' } }}>
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={isOpenSidebar}
          onClose={onCloseSidebar}
          ModalProps={{ keepMounted: true }}
          PaperProps={{ sx: { width: NAVBAR.BASE_WIDTH } }}
        >
          {renderContent}
        </Drawer>
      )}
    </>
  );
};
